import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Menu, X } from "lucide-react";

export default function Nav({ theme = "dark" }) {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const isLight = theme === "light";

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <nav className={`sv-nav ${isLight ? "light" : ""}`} data-testid="main-nav">
      <div className="sv-nav-inner">
        <Link to="/" className="sv-logo" data-testid="nav-logo">
          <img
            src={isLight ? "/somveil-wordmark-primary.png" : "/somveil-wordmark-reverse.png"}
            alt="Somveil"
            className="sv-logo-img"
          />
        </Link>
        <div className={`sv-nav-links ${open ? "mobile-open" : ""}`}>
          <Link to="/quiz" data-testid="nav-quiz" onClick={() => setOpen(false)}>Take the quiz</Link>
          <Link to="/doctors" data-testid="nav-doctors" onClick={() => setOpen(false)}>Find a specialist</Link>
          <Link to="/about" data-testid="nav-about" onClick={() => setOpen(false)}>About</Link>
          {user && user.role === "doctor" && (
            <Link to="/dashboard" data-testid="nav-dashboard" onClick={() => setOpen(false)}>Dashboard</Link>
          )}
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" onClick={() => setOpen(false)}>Admin</Link>
          )}
          {user ? (
            <button onClick={handleLogout} data-testid="nav-logout" className="sv-nav-cta">Log out</button>
          ) : (
            loc.pathname !== "/login" && (
              <Link to="/login" data-testid="nav-login" className="sv-nav-cta" onClick={() => setOpen(false)}>Doctor login</Link>
            )
          )}
        </div>
        <button
          className="md:hidden"
          style={{ background: "transparent", border: "none", color: isLight ? "#0B1F2A" : "white" }}
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </nav>
  );
}
